import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cell-templates',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    SmartusComponentsModule,
    TranslateModule,
  ],
  templateUrl: './cell-templates.component.html',
})
export class CellTemplatesComponent {
  @ViewChild('selectionCellTemplate', { static: true })
  selectionCellTemplateRef!: TemplateRef<any>;

  @ViewChild('dateCellTemplate', { static: true })
  dateCellTemplate: TemplateRef<void>;
}
